import React from "react";
import koppa from "../../assets/img/koppa.png";
import CountUp from "react-countup";

const Skill = () => {
  return (
    <section className="skill-wrapper theme-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-4  ">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-12">
                <div className="single-fun-fact style-2">
                  <h2>
                    <CountUp end={30} duration={3}></CountUp>K+
                  </h2>
                  <h3>Premium Quality  </h3>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-12">
                <div className="single-fun-fact style-2">
                  <h2>
                    <CountUp end={980} duration={3}></CountUp>+
                  </h2>
                  <h3>Diverse Range</h3>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-12">
                <div className="single-fun-fact style-2">
                  <h2>
                    <CountUp end={50} duration={3}></CountUp>+
                  </h2>
                  <h3>Sustainability</h3>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-12">
                <div className="single-fun-fact style-2">
                  <h2>
                    <CountUp end={98} duration={3}></CountUp>%
                  </h2>
                  <h3>Global Availability</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 text-white mt-5 mt-lg-0 col-12">
            <div className="block-contents">
              <div className="section-title mb-10">
                <span>Vision And Strategy
                </span>
                <h2>Empowering Growth Through Innovation and Expertise</h2>
              </div>
              <p>
              expansion by diversifying our product offerings and investing in advanced manufacturing technologies. This strategic evolution has driven consistent year-on-year growth across various sectors.
              </p>
            </div>

            <div className="skill-wrapper">
              <div className="single-progress-bar">
                <div className="title justify-content-between d-flex align-items-center">
                  <h5>Sourcing & Production</h5>
                  <span
                    className="wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="1s"
                  >
                    90%
                  </span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="2s"
                    data-wow-delay=".1s"
                    role="progressbar"
                    style={{ width: "90%" }}
                  ></div>
                </div>
              </div>
              <div className="single-progress-bar">
                <div className="title justify-content-between d-flex align-items-center">
                  <h5>Processing & Refining  </h5>
                  <span
                    className="wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="1.3s"
                  >
                    87%
                  </span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="2s"
                    data-wow-delay=".5s"
                    role="progressbar"
                    style={{ width: "87%" }}
                  ></div>
                </div>
              </div>
              <div className="single-progress-bar">
                <div className="title justify-content-between d-flex align-items-center">
                  <h5>Storage & Logistics  </h5>
                  <span
                    className="wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="1.6s"
                  >
                    94%
                  </span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="2s"
                    data-wow-delay=".9s"
                    role="progressbar"
                    style={{ width: "94%" }}
                  ></div>
                </div>
              </div>
              <div className="single-progress-bar">
                <div className="title justify-content-between d-flex align-items-center">
                  <h5>Market Research  </h5>
                  <span
                    className="wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="1.6s"
                  >
                    94%
                  </span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="2s"
                    data-wow-delay=".9s"
                    role="progressbar"
                    style={{ width: "94%" }}
                  ></div>
                </div>
              </div>
              <div className="single-progress-bar">
                <div className="title justify-content-between d-flex align-items-center">
                  <h5>Customization & Distribution  </h5>
                  <span
                    className="wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="1.6s"
                  >
                    94%
                  </span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar wow fadeInLeft"
                    data-wow-duration="2s"
                    data-wow-delay=".9s"
                    role="progressbar"
                    style={{ width: "94%" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="koppa-img d-none d-xxl-block">
        <img
          src={koppa}
          alt=""
          className="wow fadeInLeft"
          data-wow-delay=".4s"
          data-wow-duration="1.5s"
        />
      </div> */}
    </section>
  );
};

export default Skill;
